import * as Sentry from '@sentry/nextjs';

export enum ModeBreadcrumbModal {
  OPEN = 'Open',
  CLOSE = 'Close',
}

export enum ModalsList {
  REGISTRATION = 'registration',
  LOGIN = 'login',
  DEPOSIT = 'deposit',
  RECOVERY = 'recovery',
  LEAVE_REGISTRATION = 'leaveRegistration',
}

export function addBreadcrumbModal(mode: ModeBreadcrumbModal, modal: string) {
  Sentry.addBreadcrumb({
    category: 'modal',
    message: `${mode} ${modal} modal`,
    level: 'info',
  });
}
